import React from 'react'

const FormRadio = ({ name, size, status, label, image, disabled, value, onClick, checked, id, color, className }) => {
  return (
    <label
      className={
        `formradio` +
        (size ? ` formradio--${size}` : ' formradio--md') +
        (status ? ` formradio--${status}` : '') +
        (image ? ' formradio--with-image' : '') +
        (className ? ` ${className}` : '')
      }
      htmlFor={id}
    >
      <input
        onChange={onClick}
        checked={checked}
        name={name}
        value={value}
        className={`formradio__radio ${color === "blue" ? 'formradio__radio--blue' : ''}`}
        type="radio"
        disabled={disabled}
        id={id}
      />
      <span className="formradio__styledradio"></span>
      {image && <span className="formradio__image">{image}</span>}
      <span className="formradio__label">{label}</span>
    </label>
  )
}

export default FormRadio
